import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    type LazyComponent,
    LazyModule,
    registerLazyOrchestrator,
} from 'owa-bundling';
import type { FluentNovaMeControlProps } from './components/FluentNovaMeControlProps';
import { FluentNovaMeControlPlaceholder } from './components/FluentNovaMeControlPlaceholder';
import { onAddNewAccount } from 'owa-nova-actions/lib/actions/onAddNewAccount';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OwaFluentNovaMeControl" */ './lazyIndex'),
    { name: 'OwaFluentNovaMeControl' }
);

registerLazyOrchestrator(onAddNewAccount, lazyModule, m => m.onAddNewAccountOrchestrator);

export const FluentNovaMeControl: LazyComponent<FluentNovaMeControlProps, unknown, void> =
    createLazyComponent(
        lazyModule,
        m => m.FluentNovaMeControl,
        FluentNovaMeControlPlaceholder // placeholder
    );
